let apiURL // 接口地址
let coursewareURL // 课件地址
let qoeURL // qoe打点地址
let env = "" // 当前环境

let baseURL = {
  apiURL: {
    test: "https://qa-gw-openclass.vipkid-qa.com.cn",
    stage: "https://qa-gw-openclass.vipkid-qa.com.cn",
    pre: "https://pre-openclass-service.vipkid.com.cn",
    online: "https://openclass-service.vipkid.com.cn"
  },
  coursewareURL: {
    test: "https://stage-openclass-live-cdn.vipkid-qa.com.cn/rich-courseware",
    stage: "https://stage-openclass-live-cdn.vipkid-qa.com.cn/rich-courseware",
    pre: "https://pre-openclass-courseware.vipkid.com.cn/courseware",
    online: "https://openclass-courseware.vipkid.com.cn/courseware"
  },
  qoeURL: {
    test: "https://songbird-c.vipkid.com.cn/theme/testdata_1vn_av_data",
    stage: "https://songbird-c.vipkid.com.cn/theme/testdata_1vn_av_data",
    pre: "https://songbird-c.vipkid.com.cn/theme/raw_1vn_av_data",
    online: "https://songbird-c.vipkid.com.cn/theme/raw_1vn_av_data"
  }
}

if (
  window.location.origin.indexOf("localhost") > 0 ||
  window.location.origin.indexOf("192") > 0
) {
  env = "test"
} else if (
  window.location.origin.indexOf("stage") > 0 ||
  window.location.origin.indexOf("qa-gw") > 0
) {
  env = "stage"
} else if (window.location.origin.indexOf("pre") > 0) {
  env = "pre"
} else {
  env = "online"
}

apiURL = baseURL.apiURL[env]
coursewareURL = baseURL.coursewareURL[env]
qoeURL = baseURL.qoeURL[env]

export { apiURL, coursewareURL, qoeURL, env }
